<template>
  <el-header height="64px">
    <div class="container">
      <div class="account-content">
        <el-dropdown size="medium" @command="handleCommand">
          <div class="user-info">
            <el-avatar shape="circle" size="medium" :src="userInfo.headImg">
              <img src="../../assets/images/user-avatar.png" alt="默认头像" />
            </el-avatar>
            <span class="name">admin</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in dropMenu"
              :key="index"
              :command="item.command"
              :icon="item.icon"
              :divided="item.divided"
            >{{item.name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dialog
          title="修改密码"
          :close-on-click-modal="false"
          :visible.sync="dialogVisible"
          :modal-append-to-body="false"
          width="25%"
        >
          <el-input v-model="password" placeholder="请输入6位数字格式的密码"></el-input>
          <div class="submit">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" :loading="loading" @click="handleModify">保存</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </el-header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { validPassword } from '@/utils/validate';

const LOGOUT = 'LOGOUT';
const MODIFY = 'MODIFY';

export default {
  name: 'GlobalHeader',
  data() {
    return {
      loading: false,
      password: '',
      dialogVisible: false,
      dropMenu: [
        {
          name: '修改密码',
          icon: 'el-icon-edit',
          command: MODIFY,
          divided: false,
        },
        {
          name: '退出',
          icon: 'el-icon-switch-button',
          command: LOGOUT,
          divided: false,
        },
      ],
      navs: [{ title: '首页', path: '/', active: true }],
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    ...mapActions({
      logout: 'user/logout',
      modifyPassword: 'user/modifyPassword',
    }),
    handleCommand(command) {
      switch (command) {
        case LOGOUT:
          this.handleLogout();
          break;
        case MODIFY:
          this.dialogVisible = true;
          break;
        default:
          break;
      }
    },
    handleLogout() {
      return this.logout()
        .then(() => {
          this.$message.success('您已成功退出！');
          this.$router.push('/user/login');
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    updatePassword() {
      const { password } = this;
      return this.modifyPassword(password)
        .then((res) => {
          if (res.success) {
            this.loading = false;
            this.$message.success('密码修改成功');
            this.handleLogout();
          } else {
            this.$message.error(res.message);
          }
        });
    },
    handleModify() {
      if (validPassword(this.password)) {
        this.loading = true;
        this.updatePassword();
      } else {
        this.$message.error('请输入正确格式的密码');
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~assets/css/mixins'
.el-header
  display flex
  flex-flow row nowrap
  align-items stretch
  justify-content center
  background-color #ffffff
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  z-index 2
  .container
    width 100%
    height 100%
    flex-row-nowrap()
    justify-content flex-end
    color #FFFFFF
    .nav-content
      flex-row-nowrap()
      .logo
        margin-right 140px
        cursor pointer
        img
          height 40px
      .navs
        display flex
        flex-flow row nowrap
        align-items center
        li
          position relative
          font-size 14px
          margin-right 30px
          color #999999
          &:last-child
            margin-right 0
          &:hover, &.active
            color #FFFFFF
            &::after
              content ''
              position absolute
              left 0
              bottom -8px
              width 100%
              height 2px
              background-color #FFFFFF
              border-radius 1px
    .account-content
      flex-row-nowrap()
      justify-content space-between
      .user-info
        flex-row-nowrap()
        cursor default
        .name
          color rgba(0, 0, 0, 0.65)
          margin-left 10px
.submit
  width 100%
  text-align center
  margin-top 30px
</style>
